import apiAxios from '@/services/axiosConfig';
import type { UserSettings } from '@/types/api';

async function getSettings(): Promise<UserSettings> {
  const response = await apiAxios.get<UserSettings>('/api/v1/mt/settings');
  return response.data;
}

export default getSettings;
